
export function refreshTokenRequestBody(refresh_token: string, client_id: string): string {
  const params = new URLSearchParams({
    grant_type: 'refresh_token',
    refresh_token,
    client_id
  });
  return params.toString();
}

export const refreshTokenRequestContentType = 'application/x-www-form-urlencoded';
